import i18next from 'i18next';
import backend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import enLocales from '../fenrir/en';
import frLocales from '../fenrir/fr';

const instance = i18next.createInstance();

instance
  .use(ICU)
  .use(backend)
  .use(initReactI18next)
  .init({
    partialBundledLanguages: true,
    ns: [],
    resources: {
      en: {
        fenrir: enLocales,
      },
      fr: {
        fenrir: frLocales,
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default instance;
